import React from 'react'
import { Translate } from 'next-translate'
import { Header } from '@app/components/general/header'
import { BlogDate } from '@app/components/blog/blog-date'
import { Category } from '@app/components/stateless/card/category'
import { P } from '@app/components/stateless/typo/p'

// The header intro
export const ArticleHeader = ({
  date,
  t,
  category,
}: {
  date?: Date
  t: Translate
  category?: string
}) => {
  return (
    <div className='space-y-1 pt-12'>
      {date ? <BlogDate date={date} /> : null}
      <div className='flex place-items-center space-x-4 py-2'>
        <Header className='p-0 md:p-0 lg:p-0 xl:p-0'>{t('header')}</Header>
        {category ? (
          <Category category={category} pure translation='guides' />
        ) : null}
      </div>
      <P>{t('header-details')}</P>
    </div>
  )
}
